import React, { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./GoogleReviews.module.css"; // Import module CSS

const WORDPRESS_API_URL = "https://studiomaamangala.com/wp-json/custom/v1/reviews";

const GoogleReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [topIndex, setTopIndex] = useState(1); // Track highest zIndex
  const sectionRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(WORDPRESS_API_URL);
        const data = await response.json();
        setReviews(data);
      } catch (error) {
        console.error("Error fetching Google reviews:", error);
      }
    };

    fetchReviews();

    // Detect screen size changes
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div ref={sectionRef} className={styles.reviewsSection}>
      <h2>Find The Lovable Reviews</h2>

      {/* Display reviews on both Desktop & Mobile */}
      <div className={styles.notificationWrapper}>
        <AnimatePresence>
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              className={styles.notificationCard}
              style={{ zIndex: topIndex === index ? 10 : index }}
              initial={{ opacity: 0, y: 50, rotate: isMobile ? 0 : Math.random() * 20 - 10 }}
              animate={{ opacity: 1, y: 0, rotate: isMobile ? 0 : Math.random() * 20 - 10 }}
              exit={{ opacity: 0, y: 50 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              drag={!isMobile} // ✅ Enable dragging only on PC
              dragConstraints={isMobile ? false : { left: -600, right: 600, top: -50, bottom: 50 }} // ✅ Unlimited movement on PC
              dragMomentum={true} // ✅ Allows smooth movement after drag
              dragElastic={0.5} // ✅ Adds smooth elasticity when dragging
              whileHover={{ scale: isMobile ? 1.02 : 1.05 }}
              onMouseDown={() => setTopIndex(index)} // Brings clicked card to the front
            >
              <div className={styles.notificationContent}>
                <img
                  src={review.profile_photo_url}
                  alt={review.author_name}
                  className={styles.profileImage}
                />
                <div className={styles.textContent}>
                  <h4>
                    <a href={review.author_url} target="_blank" rel="noopener noreferrer">
                      {review.author_name}
                    </a>
                  </h4>
                  <p className={styles.rating}>⭐ {review.rating}</p>
                  <p>
                    {review.text.length > 120 ? review.text.substring(0, 120) + "..." : review.text}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default GoogleReviews;
